import { useState } from "react";
import { Box, InputBase, useTheme } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function ListSearchField({ placeholder, onSearch, defaultValue = "" }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const textPri = theme.palette.neutral.dark;
  const textSec = theme.palette.neutral.main;
  const accent = theme.palette.secondary.main;
  const border = isDark ? "rgba(29,158,117,0.14)" : "rgba(29,158,117,0.16)";

  const [value, setValue] = useState(defaultValue);

  const submit = () => onSearch(value);

  return (
    <Box sx={{
      display: "flex", alignItems: "center", gap: "6px",
      px: "0.75rem", height: "36px",
      backgroundColor: isDark ? "rgba(255,255,255,0.04)" : "#f9f9f9",
      border: `1px solid ${border}`,
      borderRadius: "8px",
      flex: "1 1 180px",
      maxWidth: "260px",
    }}>
      <SearchIcon sx={{ fontSize: "16px", color: textSec }} />
      <InputBase
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") submit(); }}
        sx={{ flex: 1, fontSize: "13px", color: textPri }}
      />
      <Box
        onClick={submit}
        sx={{
          fontSize: "11px", fontWeight: 500, color: accent,
          cursor: "pointer", "&:hover": { textDecoration: "underline" },
        }}
      >
        Search
      </Box>
    </Box>
  );
}
